window.nffleet_functions = {
    getPopUpWrapperWithBackground: function () {
        var variables = window.nffleet_variables;

        var html = document.documentElement;
        html.style.cssText = "overflow: hidden;";

        var body = document.getElementsByTagName(variables.bodyTag)[0];

        var background = document.createElement(variables.divTag);
        background.id = "background-overlay";
        background.classList.add("mfp-bg");
        background.classList.add("mfp-ready");

        var contentWrapper = document.createElement(variables.divTag);
        contentWrapper.classList.add("mfp-wrap");
        contentWrapper.classList.add("mfp-close-btn-in");
        contentWrapper.classList.add("mfp-auto-cursor");
        contentWrapper.classList.add("mfp-ready");

        var siteWrapper = body.getElementsByClassName("site-wrapper")[0];

        body.insertBefore(contentWrapper, siteWrapper);
        body.insertBefore(background, siteWrapper);

        contentWrapper.addEventListener(variables.destroyListener,
            function () {

                var variables = window.nffleet_variables;

                var html = document.documentElement;
                var body = document.getElementsByTagName(variables.bodyTag)[0];
                var background = document.getElementById("background-overlay");

                html.style.cssText = variables.emptyString;
                body.removeChild(background);
                body.removeChild(this);
            });

        return contentWrapper;
    },
    handleClass: function (element, className, add) {
        if (element) {
            if (add) {
                element.classList.add(className);
            } else {
                element.classList.remove(className);
            }
        }
    }
};